import {
  changeDuration,
  createDuration,
  getConfig,
} from "@/services/endpoints/siteSettings";

export default {
  async changeDuration({ commit }, { payload: payload, configId: configId }) {
    try {
      let res = await changeDuration({ payload: payload, configId: configId });
      if (res) {
        return res.data;
      } else {
        throw {};
      }
    } catch (err) {
      throw err;
    }
  },
  async createDuration({ commit }, payload) {
    try {
      let res = await createDuration(payload);
      if (res) {
        return res.data;
      } else {
        throw {};
      }
    } catch (err) {
      throw err;
    }
  },
  async getConfig({ commit }) {
    try {
      let res = await getConfig();
      if (res) {
        commit("SET_DURATION", res.data.notDuplicateTurnMin);
        return res.data;
      } else {
        throw {};
      }
    } catch (err) {
      throw err;
    }
  },
};
